import React, { useState, useCallback, useContext } from "react";
import { useNotificationSocket } from "../context/SocketContext";
import { AuthContext } from "../context/AuthContext";
import ToastNotification from "./ToastNotification";

const MAX_TOASTS = 3;

const ToastContainer = ({ onNotification }) => {
  const { user } = useContext(AuthContext);
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(
    (notification) => {
      // Don't show toasts for own actions
      if (notification.actorId === user?.userId) return;

      const id = notification._id || Date.now().toString();
      setToasts((prev) => {
        const next = [{ ...notification, toastId: id }, ...prev];
        return next.slice(0, MAX_TOASTS);
      });

      // Notify parent (for badge count increment)
      if (onNotification) {
        onNotification(notification);
      }
    },
    [user?.userId, onNotification]
  );

  const dismissToast = useCallback((toastId) => {
    setToasts((prev) => prev.filter((t) => t.toastId !== toastId));
  }, []);

  // Wire up the existing notification socket hook
  useNotificationSocket(addToast);

  if (toasts.length === 0) return null;

  return (
    <>
      {/* Desktop: bottom-right stack */}
      <div className="hidden lg:flex fixed bottom-6 right-6 z-[60] flex-col-reverse gap-3 pointer-events-none">
        {toasts.map((toast) => (
          <div key={toast.toastId} className="pointer-events-auto">
            <ToastNotification
              notification={toast}
              onDismiss={() => dismissToast(toast.toastId)}
            />
          </div>
        ))}
      </div>

      {/* Mobile: top stack (below top bar) */}
      <div className="lg:hidden fixed top-16 left-0 right-0 z-[60] flex flex-col gap-2 px-3 pointer-events-none">
        {toasts.map((toast) => (
          <div key={toast.toastId} className="pointer-events-auto">
            <ToastNotification
              notification={toast}
              onDismiss={() => dismissToast(toast.toastId)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ToastContainer;
